import { Api } from './api';

export class Auth {
  static async hasSession() {
    let api = new Api();
    const session = await api.get('/session');

    return session && session.model;
  }

  static async destroySession() {
    let api = new Api();
    const session = await api.delete('/session');

    return session && session.model;
  }

  static setCookie(name, value, days) {
    let expires = '';
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    // Armazenar também no localStorage para compartilhamento entre domínios
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      console.error('Erro ao armazenar token no localStorage:', e);
    }

    // Cookie para o domínio atual
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
  }

  // Método para obter o token, seja do cookie ou localStorage
  static getAuthToken() {
    // Primeiro tenta pegar do cookie
    const cookies = document.cookie.split('; ');
    let cookieValue = null;

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      if (cookie.startsWith('auth-token=')) {
        cookieValue = cookie.split('=')[1];
        break;
      }
    }

    if (cookieValue) return cookieValue;

    // Se não encontrou no cookie, tenta no localStorage
    try {
      return localStorage.getItem('auth-token');
    } catch (e) {
      console.error('Erro ao recuperar token do localStorage:', e);
      return null;
    }
  }

  static async getSessionData() {
    let api = new Api();
    const session = await api.get('/session/data');

    if (session.model && session.model.user) {
      this.setCookie('auth-token', session.model.user, 7); // Cookie válido por 7 dias
    }

    return session && session.model;
  }

  // Método para iniciar login SSO
  static initiateSSO(targetDomain) {
    const token = this.getAuthToken();
    if (!token) return false;

    // Redireciona para o outro domínio com o token como parâmetro
    const redirectUrl = targetDomain + '/sso-login?token=' + encodeURIComponent(token);

    window.location.href = redirectUrl;
    return true;
  }
}
